/* Ferme review slider. Initialises every [data-ferme-revs] block on the page.
   Kept out of the block file so that file stays small enough to edit through
   the Admin API. */
(function () {
  function init(root) {
    if (!root || root.dataset.frsInit) return;
    root.dataset.frsInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.frs__slide'));
    var dotWrap = root.querySelector('.frs__dots');
    if (!slides.length) return;

    var interval = parseInt(root.dataset.interval, 10) || 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0, timer = null, paused = false, dots = [], clearOut = null;

    if (slides.length > 1 && dotWrap) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'frs__dot';
        b.setAttribute('aria-label', 'Show review ' + (i + 1));
        b.addEventListener('click', function () { go(i); start(); });
        dotWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(i) {
      var next = (i + slides.length) % slides.length;
      if (next === index && slides[index].classList.contains('is-on')) return;
      var prev = slides[index];
      index = next;
      if (clearOut) { clearTimeout(clearOut); clearOut = null; }
      slides.forEach(function (s) { s.classList.remove('is-out'); });
      if (prev && prev !== slides[index] && prev.classList.contains('is-on')) {
        prev.classList.remove('is-on');
        prev.classList.add('is-out');
        prev.setAttribute('aria-hidden', 'true');
        clearOut = setTimeout(function () { prev.classList.remove('is-out'); }, 600);
      }
      slides.forEach(function (s, n) {
        if (n === index) { s.classList.add('is-on'); s.setAttribute('aria-hidden', 'false'); }
        else if (!s.classList.contains('is-out')) { s.classList.remove('is-on'); s.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === index); });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduceMotion || interval <= 0 || slides.length < 2) return;
      timer = setInterval(function () { if (!paused) go(index + 1); }, interval);
    }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; paused = true; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      sx = null;
      paused = false;
    }, { passive: true });

    slides[0].classList.add('is-on');
    slides[0].setAttribute('aria-hidden', 'false');
    if (dots[0]) dots[0].classList.add('is-on');
    start();
  }

  function boot() {
    document.querySelectorAll('[data-ferme-revs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
